import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useCallback } from 'react';
import { ChatState, IS_IE } from 'sdk';

import { useSDK } from '../../../../../app';
import { useUIState } from '../../../../../app/App';
import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';
import { truncFilename } from '../../../../../utils/truncFilename';
import { DeleteAttachmentIcon } from './icons/deleteAttachmentIcon';
import { FileIcon } from './icons/fileIcon';
import { ImageAttachmentPreview } from './imageAttachmentPreview';

const styles = css`
	align-items: center;
	display: flex;
	width: 100%; /* IE */
	box-sizing: border-box;

	& > * {
		box-sizing: border-box;
	}

	& > .filename {
		flex: ${IS_IE ? '0 1 auto' : '1'};
		padding: 0 8px;
	}

	&.attach-preview_no-padding-top {
		padding-top: 0;
	}
`;

const Component = ({ file, className }: { file: File; className: string }): ReactElement => {
	const rootStore = useSDK();
	const { attachmentErrorsStore } = useUIState();
	const onClickHandler = useCallback(() => {
		rootStore.attachmentsStore.deleteUnsentAttachment(file);
		attachmentErrorsStore.clearError();
	}, [file, rootStore.attachmentsStore, attachmentErrorsStore]);
	let cn = className;
	if (
		rootStore.conversationsStore.isLatestConversationResolved &&
		rootStore.uiStateStore.chatState !== ChatState.chat
	) {
		cn += ' attach-preview_no-padding-top';
	}
	return (
		<div className={cn}>
			{file.type.includes('image/') ? <ImageAttachmentPreview file={file} /> : <FileIcon />}
			<span title={file.name} className="filename">
				{truncFilename(file.name, 12)}
			</span>
			<DeleteAttachmentIcon onClick={onClickHandler} />
		</div>
	);
};

export const UnsentAttachmentPreview = styled(observer(Component))(
	({ theme }: { theme: Theme }) => theme.chat.attachments.unsentAttachmentPreview,
	styles
);
